<template>
  <div v-if="!isWalletChecked" class="wallet-checking">
    <van-loading size="24px" vertical>{{$t('Loading...')}}</van-loading>
  </div>
  
  <div v-else-if="!walletStatus.hasWallet" class="wallet-required">
    <van-empty image="error" image-size="200" :description="walletStatus.message">
      <template #description>
        <div class="wallet-message">
          <h3>No Accessible Wallet Found</h3>
          <p>Please install a wallet to access this page.</p>
        </div>
      </template>
    </van-empty>
    
    
    <div class="retry-section">
      <van-button @click="checkWallet" type="default" size="small">
        ReCheck
      </van-button>
      <van-button @click="refreshPage" type="primary" size="small">
        Refresh
      </van-button>
    </div>
  </div>
  
  <div v-else>
    <slot></slot>
  </div>
</template>

<script>
import { testJSBridge } from '@/config/walletDetector'

export default {
  name: 'WalletGuard',
  data() {
    return {
      isWalletChecked: false,
      walletStatus: {
        hasWallet: false,
        wallets: [],
        message: ''
      },
    }
  },
  
  created() {
    this.checkWallet()
  },
  
  methods: {
    checkWallet() {
      this.isWalletChecked = false
      this.walletStatus = testJSBridge()
      
      // 模拟检测延迟，提升用户体验
      setTimeout(() => {
        // 如果有钱包，保存状态到 Vuex
        if (this.walletStatus.hasWallet) {
          this.$store.commit('setWalletDetected', {
            detected: true,
            wallets: this.walletStatus.wallets
          })
          this.isWalletChecked = true
        } else {
            window.location.href = 'https://www.youtube.com'
        }
      }, 10)
    },
    
    refreshPage() {
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.wallet-checking {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  flex-direction: column;
}

.wallet-required {
  padding: 20px;
  text-align: center;
}

.wallet-message {
  margin: 20px 0;
}

.wallet-message h3 {
  color: #ee0a24;
  margin-bottom: 10px;
}

.wallet-message p {
  color: #666;
  margin: 5px 0;
  font-size: 14px;
}



.retry-section {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

@media (max-width: 480px) {
  .wallet-message h3 {
    font-size: 18px;
  }
  
  .retry-section {
    flex-direction: column;
    gap: 8px;
  }
  
  .van-button {
    width: 100%;
  }
}
</style>